var cov_2q5f7otq5q = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tree/Content.tsx",
      hash = "b70384a3ae4ac8b7198d71c5ca4db65f43ad1831",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tree/Content.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 14,
          column: 9
        }
      },
      "1": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 16
        }
      },
      "2": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 58
        }
      },
      "3": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 60
        }
      },
      "4": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 68
        }
      },
      "5": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 52
        }
      },
      "6": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 29
        }
      },
      "7": {
        start: {
          line: 29,
          column: 22
        },
        end: {
          line: 29,
          column: 32
        }
      },
      "8": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 52
        }
      },
      "9": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 32
        }
      },
      "10": {
        start: {
          line: 35,
          column: 22
        },
        end: {
          line: 35,
          column: 32
        }
      },
      "11": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 54
        }
      },
      "12": {
        start: {
          line: 40,
          column: 57
        },
        end: {
          line: 40,
          column: 67
        }
      },
      "13": {
        start: {
          line: 41,
          column: 21
        },
        end: {
          line: 41,
          column: 65
        }
      },
      "14": {
        start: {
          line: 42,
          column: 24
        },
        end: {
          line: 42,
          column: 55
        }
      },
      "15": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 47,
          column: 5
        }
      },
      "16": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 33
        }
      },
      "17": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 38
        }
      },
      "18": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 22
        }
      },
      "19": {
        start: {
          line: 55,
          column: 53
        },
        end: {
          line: 55,
          column: 63
        }
      },
      "20": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 34
        }
      },
      "21": {
        start: {
          line: 56,
          column: 28
        },
        end: {
          line: 56,
          column: 34
        }
      },
      "22": {
        start: {
          line: 57,
          column: 21
        },
        end: {
          line: 57,
          column: 65
        }
      },
      "23": {
        start: {
          line: 58,
          column: 24
        },
        end: {
          line: 58,
          column: 55
        }
      },
      "24": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 48
        }
      },
      "25": {
        start: {
          line: 59,
          column: 21
        },
        end: {
          line: 59,
          column: 48
        }
      },
      "26": {
        start: {
          line: 63,
          column: 69
        },
        end: {
          line: 63,
          column: 79
        }
      },
      "27": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 14
        }
      },
      "28": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 47
        }
      },
      "29": {
        start: {
          line: 67,
          column: 41
        },
        end: {
          line: 67,
          column: 47
        }
      },
      "30": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 21
        }
      },
      "31": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 52
        }
      },
      "32": {
        start: {
          line: 70,
          column: 16
        },
        end: {
          line: 70,
          column: 52
        }
      },
      "33": {
        start: {
          line: 74,
          column: 55
        },
        end: {
          line: 74,
          column: 65
        }
      },
      "34": {
        start: {
          line: 75,
          column: 19
        },
        end: {
          line: 75,
          column: 97
        }
      },
      "35": {
        start: {
          line: 75,
          column: 84
        },
        end: {
          line: 75,
          column: 97
        }
      },
      "36": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 58
        }
      },
      "37": {
        start: {
          line: 80,
          column: 86
        },
        end: {
          line: 80,
          column: 96
        }
      },
      "38": {
        start: {
          line: 81,
          column: 21
        },
        end: {
          line: 81,
          column: 65
        }
      },
      "39": {
        start: {
          line: 82,
          column: 17
        },
        end: {
          line: 82,
          column: 109
        }
      },
      "40": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 89,
          column: 10
        }
      },
      "41": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 57
        }
      },
      "42": {
        start: {
          line: 92,
          column: 41
        },
        end: {
          line: 92,
          column: 57
        }
      },
      "43": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 65
        }
      },
      "44": {
        start: {
          line: 93,
          column: 54
        },
        end: {
          line: 93,
          column: 65
        }
      },
      "45": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 45
        }
      },
      "46": {
        start: {
          line: 95,
          column: 31
        },
        end: {
          line: 95,
          column: 45
        }
      },
      "47": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 45
        }
      },
      "48": {
        start: {
          line: 96,
          column: 29
        },
        end: {
          line: 96,
          column: 45
        }
      },
      "49": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 15
        }
      },
      "50": {
        start: {
          line: 102,
          column: 73
        },
        end: {
          line: 102,
          column: 83
        }
      },
      "51": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 114,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 52
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 22
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 27
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 25
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 33
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        loc: {
          start: {
            line: 39,
            column: 20
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 39
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 17
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 50
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 54,
            column: 2
          },
          end: {
            line: 54,
            column: 3
          }
        },
        loc: {
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 54
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        loc: {
          start: {
            line: 62,
            column: 25
          },
          end: {
            line: 71,
            column: 3
          }
        },
        line: 62
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        loc: {
          start: {
            line: 73,
            column: 15
          },
          end: {
            line: 77,
            column: 3
          }
        },
        line: 73
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 75,
            column: 67
          },
          end: {
            line: 75,
            column: 68
          }
        },
        loc: {
          start: {
            line: 75,
            column: 84
          },
          end: {
            line: 75,
            column: 97
          }
        },
        line: 75
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        },
        loc: {
          start: {
            line: 79,
            column: 20
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 79
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        },
        loc: {
          start: {
            line: 101,
            column: 11
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 101
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 42,
            column: 24
          },
          end: {
            line: 42,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 24
          },
          end: {
            line: 42,
            column: 32
          }
        }, {
          start: {
            line: 42,
            column: 36
          },
          end: {
            line: 42,
            column: 55
          }
        }],
        line: 42
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 19
          }
        }, {
          start: {
            line: 43,
            column: 23
          },
          end: {
            line: 43,
            column: 40
          }
        }],
        line: 43
      },
      "3": {
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 34
          }
        }, {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 34
          }
        }],
        line: 56
      },
      "4": {
        loc: {
          start: {
            line: 58,
            column: 24
          },
          end: {
            line: 58,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 24
          },
          end: {
            line: 58,
            column: 32
          }
        }, {
          start: {
            line: 58,
            column: 36
          },
          end: {
            line: 58,
            column: 55
          }
        }],
        line: 58
      },
      "5": {
        loc: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 48
          }
        }, {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 48
          }
        }],
        line: 59
      },
      "6": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 47
          }
        }, {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 47
          }
        }],
        line: 67
      },
      "7": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 52
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 52
          }
        }],
        line: 70
      },
      "8": {
        loc: {
          start: {
            line: 75,
            column: 19
          },
          end: {
            line: 75,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 75,
            column: 54
          },
          end: {
            line: 75,
            column: 64
          }
        }, {
          start: {
            line: 75,
            column: 67
          },
          end: {
            line: 75,
            column: 97
          }
        }],
        line: 75
      },
      "9": {
        loc: {
          start: {
            line: 82,
            column: 17
          },
          end: {
            line: 82,
            column: 109
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 82,
            column: 31
          },
          end: {
            line: 82,
            column: 60
          }
        }, {
          start: {
            line: 82,
            column: 63
          },
          end: {
            line: 82,
            column: 109
          }
        }],
        line: 82
      },
      "10": {
        loc: {
          start: {
            line: 82,
            column: 43
          },
          end: {
            line: 82,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 82,
            column: 54
          },
          end: {
            line: 82,
            column: 55
          }
        }, {
          start: {
            line: 82,
            column: 58
          },
          end: {
            line: 82,
            column: 59
          }
        }],
        line: 82
      },
      "11": {
        loc: {
          start: {
            line: 86,
            column: 48
          },
          end: {
            line: 86,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 86,
            column: 59
          },
          end: {
            line: 86,
            column: 64
          }
        }, {
          start: {
            line: 86,
            column: 67
          },
          end: {
            line: 86,
            column: 73
          }
        }],
        line: 86
      },
      "12": {
        loc: {
          start: {
            line: 88,
            column: 9
          },
          end: {
            line: 88,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 88,
            column: 38
          },
          end: {
            line: 88,
            column: 48
          }
        }, {
          start: {
            line: 88,
            column: 51
          },
          end: {
            line: 88,
            column: 55
          }
        }],
        line: 88
      },
      "13": {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 57
          }
        }, {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 57
          }
        }],
        line: 92
      },
      "14": {
        loc: {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 92,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 92,
            column: 16
          }
        }, {
          start: {
            line: 92,
            column: 20
          },
          end: {
            line: 92,
            column: 39
          }
        }],
        line: 92
      },
      "15": {
        loc: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 65
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 65
          }
        }],
        line: 93
      },
      "16": {
        loc: {
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 93,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 93,
            column: 31
          }
        }, {
          start: {
            line: 93,
            column: 35
          },
          end: {
            line: 93,
            column: 52
          }
        }],
        line: 93
      },
      "17": {
        loc: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 45
          }
        }, {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 45
          }
        }],
        line: 95
      },
      "18": {
        loc: {
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 95,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 95,
            column: 16
          }
        }, {
          start: {
            line: 95,
            column: 20
          },
          end: {
            line: 95,
            column: 29
          }
        }],
        line: 95
      },
      "19": {
        loc: {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 96,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 96,
            column: 45
          }
        }, {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 96,
            column: 45
          }
        }],
        line: 96
      },
      "20": {
        loc: {
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 96,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 96,
            column: 14
          }
        }, {
          start: {
            line: 96,
            column: 18
          },
          end: {
            line: 96,
            column: 27
          }
        }],
        line: 96
      },
      "21": {
        loc: {
          start: {
            line: 108,
            column: 11
          },
          end: {
            line: 108,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 108,
            column: 11
          },
          end: {
            line: 108,
            column: 19
          }
        }, {
          start: {
            line: 108,
            column: 23
          },
          end: {
            line: 108,
            column: 66
          }
        }],
        line: 108
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Tree/Content.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { treeClass } from './styles';
import Spin from '../Spin';
import Checkbox from './Checkbox';
import { CHANGE_TOPIC } from '../Datum/types';
var loading = (cov_2q5f7otq5q.s[0]++,
/*#__PURE__*/
React.createElement("span", {
  className: treeClass('icon-loading'),
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 12,
    columnNumber: 3
  }
},
/*#__PURE__*/
React.createElement(Spin, {
  name: "ring",
  size: 12,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 13,
    columnNumber: 5
  }
})));

var Content =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Content, _PureComponent);

  var _super = _createSuper2(Content);

  function Content(props) {
    var _this;

    _classCallCheck(this, Content);

    cov_2q5f7otq5q.f[0]++;
    cov_2q5f7otq5q.s[1]++;
    _this = _super.call(this, props);
    cov_2q5f7otq5q.s[2]++;
    _this.handleNodeClick = _this.handleNodeClick.bind(_assertThisInitialized(_this));
    cov_2q5f7otq5q.s[3]++;
    _this.handleNodeExpand = _this.handleNodeExpand.bind(_assertThisInitialized(_this));
    cov_2q5f7otq5q.s[4]++;
    _this.handleIndicatorClick = _this.handleIndicatorClick.bind(_assertThisInitialized(_this));
    cov_2q5f7otq5q.s[5]++;
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Content, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_2q5f7otq5q.f[1]++;
      cov_2q5f7otq5q.s[6]++;

      _get(_getPrototypeOf(Content.prototype), "componentDidMount", this).call(this);

      var _ref = (cov_2q5f7otq5q.s[7]++, this.props),
          datum = _ref.datum;

      cov_2q5f7otq5q.s[8]++;
      datum.subscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_2q5f7otq5q.f[2]++;
      cov_2q5f7otq5q.s[9]++;

      _get(_getPrototypeOf(Content.prototype), "componentWillUnmount", this).call(this);

      var _ref2 = (cov_2q5f7otq5q.s[10]++, this.props),
          datum = _ref2.datum;

      cov_2q5f7otq5q.s[11]++;
      datum.unsubscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "handleNodeClick",
    value: function handleNodeClick() {
      cov_2q5f7otq5q.f[3]++;

      var _ref3 = (cov_2q5f7otq5q.s[12]++, this.props),
          data = _ref3.data,
          id = _ref3.id,
          parentClickExpand = _ref3.parentClickExpand,
          childrenKey = _ref3.childrenKey;

      var children = (cov_2q5f7otq5q.s[13]++, data[childrenKey]);
      var hasChildren = (cov_2q5f7otq5q.s[14]++, (cov_2q5f7otq5q.b[0][0]++, children) && (cov_2q5f7otq5q.b[0][1]++, children.length > 0));
      cov_2q5f7otq5q.s[15]++;

      if ((cov_2q5f7otq5q.b[2][0]++, hasChildren) && (cov_2q5f7otq5q.b[2][1]++, parentClickExpand)) {
        cov_2q5f7otq5q.b[1][0]++;
        cov_2q5f7otq5q.s[16]++;
        this.handleIndicatorClick();
      } else {
        cov_2q5f7otq5q.b[1][1]++;
        cov_2q5f7otq5q.s[17]++;
        this.props.onNodeClick(data, id);
      }
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      cov_2q5f7otq5q.f[4]++;
      cov_2q5f7otq5q.s[18]++;
      this.forceUpdate();
    }
  }, {
    key: "handleNodeExpand",
    value: function handleNodeExpand() {
      cov_2q5f7otq5q.f[5]++;

      var _ref4 = (cov_2q5f7otq5q.s[19]++, this.props),
          data = _ref4.data,
          childrenKey = _ref4.childrenKey,
          doubleClickExpand = _ref4.doubleClickExpand;

      cov_2q5f7otq5q.s[20]++;

      if (!doubleClickExpand) {
        cov_2q5f7otq5q.b[3][0]++;
        cov_2q5f7otq5q.s[21]++;
        return;
      } else {
        cov_2q5f7otq5q.b[3][1]++;
      }

      var children = (cov_2q5f7otq5q.s[22]++, data[childrenKey]);
      var hasChildren = (cov_2q5f7otq5q.s[23]++, (cov_2q5f7otq5q.b[4][0]++, children) && (cov_2q5f7otq5q.b[4][1]++, children.length > 0));
      cov_2q5f7otq5q.s[24]++;

      if (hasChildren) {
        cov_2q5f7otq5q.b[5][0]++;
        cov_2q5f7otq5q.s[25]++;
        this.handleIndicatorClick();
      } else {
        cov_2q5f7otq5q.b[5][1]++;
      }
    }
  }, {
    key: "handleIndicatorClick",
    value: function handleIndicatorClick() {
      cov_2q5f7otq5q.f[6]++;

      var _ref5 = (cov_2q5f7otq5q.s[26]++, this.props),
          id = _ref5.id,
          data = _ref5.data,
          onToggle = _ref5.onToggle,
          loader = _ref5.loader,
          childrenKey = _ref5.childrenKey,
          setFetching = _ref5.setFetching;

      cov_2q5f7otq5q.s[27]++;
      onToggle();
      cov_2q5f7otq5q.s[28]++;

      if (data[childrenKey] !== undefined) {
        cov_2q5f7otq5q.b[6][0]++;
        cov_2q5f7otq5q.s[29]++;
        return;
      } else {
        cov_2q5f7otq5q.b[6][1]++;
      }

      cov_2q5f7otq5q.s[30]++;
      setFetching(true);
      cov_2q5f7otq5q.s[31]++;

      if (loader) {
        cov_2q5f7otq5q.b[7][0]++;
        cov_2q5f7otq5q.s[32]++;
        loader(id, data);
      } else {
        cov_2q5f7otq5q.b[7][1]++;
      }
    }
  }, {
    key: "renderNode",
    value: function renderNode() {
      cov_2q5f7otq5q.f[7]++;

      var _ref6 = (cov_2q5f7otq5q.s[33]++, this.props),
          id = _ref6.id,
          active = _ref6.active,
          data = _ref6.data,
          renderItem = _ref6.renderItem,
          expanded = _ref6.expanded;

      var render = (cov_2q5f7otq5q.s[34]++, typeof renderItem === 'function' ? (cov_2q5f7otq5q.b[8][0]++, renderItem) : (cov_2q5f7otq5q.b[8][1]++, function (d) {
        cov_2q5f7otq5q.f[8]++;
        cov_2q5f7otq5q.s[35]++;
        return d[renderItem];
      }));
      cov_2q5f7otq5q.s[36]++;
      return render(data, expanded, active, id);
    }
  }, {
    key: "renderIndicator",
    value: function renderIndicator() {
      cov_2q5f7otq5q.f[9]++;

      var _ref7 = (cov_2q5f7otq5q.s[37]++, this.props),
          data = _ref7.data,
          expanded = _ref7.expanded,
          expandIcons = _ref7.expandIcons,
          loader = _ref7.loader,
          childrenKey = _ref7.childrenKey,
          fetching = _ref7.fetching,
          iconClass = _ref7.iconClass;

      var children = (cov_2q5f7otq5q.s[38]++, data[childrenKey]);
      var icon = (cov_2q5f7otq5q.s[39]++, expandIcons ? (cov_2q5f7otq5q.b[9][0]++, expandIcons[expanded ? (cov_2q5f7otq5q.b[10][0]++, 1) : (cov_2q5f7otq5q.b[10][1]++, 0)]) : (cov_2q5f7otq5q.b[9][1]++,
      /*#__PURE__*/
      React.createElement("span", {
        className: treeClass('default-icon'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 82,
          columnNumber: 64
        }
      })));
      var indicator = (cov_2q5f7otq5q.s[40]++,
      /*#__PURE__*/
      React.createElement("a", {
        onClick: this.handleIndicatorClick,
        className: classnames(treeClass("icon-".concat(expanded ? (cov_2q5f7otq5q.b[11][0]++, 'sub') : (cov_2q5f7otq5q.b[11][1]++, 'plus'))), iconClass),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 84,
          columnNumber: 7
        }
      }, typeof icon === 'function' ? (cov_2q5f7otq5q.b[12][0]++, icon(data)) : (cov_2q5f7otq5q.b[12][1]++, icon)));
      cov_2q5f7otq5q.s[41]++;

      if ((cov_2q5f7otq5q.b[14][0]++, children) && (cov_2q5f7otq5q.b[14][1]++, children.length > 0)) {
        cov_2q5f7otq5q.b[13][0]++;
        cov_2q5f7otq5q.s[42]++;
        return indicator;
      } else {
        cov_2q5f7otq5q.b[13][1]++;
      }

      cov_2q5f7otq5q.s[43]++;

      if ((cov_2q5f7otq5q.b[16][0]++, Array.isArray(children)) || (cov_2q5f7otq5q.b[16][1]++, children === null)) {
        cov_2q5f7otq5q.b[15][0]++;
        cov_2q5f7otq5q.s[44]++;
        return null;
      } else {
        cov_2q5f7otq5q.b[15][1]++;
      }

      cov_2q5f7otq5q.s[45]++;

      if ((cov_2q5f7otq5q.b[18][0]++, fetching) && (cov_2q5f7otq5q.b[18][1]++, !children)) {
        cov_2q5f7otq5q.b[17][0]++;
        cov_2q5f7otq5q.s[46]++;
        return loading;
      } else {
        cov_2q5f7otq5q.b[17][1]++;
      }

      cov_2q5f7otq5q.s[47]++;

      if ((cov_2q5f7otq5q.b[20][0]++, loader) && (cov_2q5f7otq5q.b[20][1]++, !fetching)) {
        cov_2q5f7otq5q.b[19][0]++;
        cov_2q5f7otq5q.s[48]++;
        return indicator;
      } else {
        cov_2q5f7otq5q.b[19][1]++;
      }

      cov_2q5f7otq5q.s[49]++;
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      cov_2q5f7otq5q.f[10]++;

      var _ref8 = (cov_2q5f7otq5q.s[50]++, this.props),
          data = _ref8.data,
          onToggle = _ref8.onToggle,
          onChange = _ref8.onChange,
          expanded = _ref8.expanded,
          onDragOver = _ref8.onDragOver,
          other = _objectWithoutProperties(_ref8, ["data", "onToggle", "onChange", "expanded", "onDragOver"]);

      cov_2q5f7otq5q.s[51]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          onDragOver: onDragOver,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 105,
            columnNumber: 7
          }
        }, this.renderIndicator(),
        /*#__PURE__*/
        React.createElement("div", {
          className: treeClass('content'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 107,
            columnNumber: 9
          }
        }, (cov_2q5f7otq5q.b[21][0]++, onChange) && (cov_2q5f7otq5q.b[21][1]++,
        /*#__PURE__*/
        React.createElement(Checkbox, Object.assign({}, other, {
          onChange: onChange,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 108,
            columnNumber: 24
          }
        }))),
        /*#__PURE__*/
        React.createElement("div", {
          className: treeClass('text'),
          onClick: this.handleNodeClick,
          onDoubleClick: this.handleNodeExpand,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 109,
            columnNumber: 11
          }
        }, this.renderNode())))
      );
    }
  }]);

  return Content;
}(PureComponent);

export default Content;